class BlackFriday extends HTMLElement {
    constructor() {
        super();

        this.buttonSlide = document.querySelector("[data-button-slider]");
        this.sliderTrack = document.querySelector("[data-slider-track]");
        this.blackFridayMessage = document.querySelector('[data-black-friday]');
    }

    connectedCallback() {

        let self = this;

        let startX = 0;
        let buttonLeft = 0;
        let isDragging = false;

        this.buttonSlide.addEventListener("mousedown", (e) => {
            isDragging = true;
            startX = e.clientX;
            buttonLeft = self.buttonSlide.offsetLeft;
            self.buttonSlide.classList.add("active");
        });

        document.addEventListener("mousemove", (e) => {
            if (!isDragging) return;
            handleMove(e.clientX);
        });

        document.addEventListener("mouseup", (e) => {
            startX = e.clientX;
            isDragging = false;
            buttonLeft = self.buttonSlide.offsetLeft;
            self.buttonSlide.classList.remove("active");
            handleReset(startX);
        });

        // Touch events for mobile
        this.buttonSlide.addEventListener("touchstart", (e) => {
            isDragging = true;
            startX = e.touches[0].clientX;
            buttonLeft = self.buttonSlide.offsetLeft;
            self.buttonSlide.classList.add("active");
        });

        document.addEventListener("touchmove", (e) => {
            if (!isDragging) return;
            handleMove(e.touches[0].clientX);
        });

        document.addEventListener("touchend", () => {
            isDragging = false;
            startX = e.clientX;
            buttonLeft = self.buttonSlide.offsetLeft;
            handleReset(startX);
            self.buttonSlide.classList.remove("active");
        });

        function handleMove(clientX) {
            const dx = clientX - startX;
            const newLeft = buttonLeft + dx;
            const maxLeft = self.sliderTrack.clientWidth - self.buttonSlide.clientWidth - 10;

            if (newLeft >= 0 && newLeft <= maxLeft) {
                self.buttonSlide.style.left = `${newLeft}px`;

                let opacityValue = newLeft / maxLeft;
                self.sliderTrack.querySelector('small').style.opacity = `${1 - opacityValue}`;
            }

            if (newLeft >= maxLeft) {
                setTimeout(() => {
                    self.sliderTrack.innerHTML = 'Activeren <span class="dots"></span>';
                    self.blackFridayMessage.classList.add('loading');

                    setTimeout(() => {
                        self.blackFridayMessage.classList.add('loaded');
                    }, 1000);

                    setTimeout(() => {
                        self.blackFridayMessage.classList.add('active');
                        document.querySelector('.block-black__friday').classList.add('active');
                        document.querySelector('[data-message]').classList.remove('hidden');

                        document.querySelector('.section-collection')?.classList.add('active');
                    }, 1500);

                }, 500);
            }
        }

        function handleReset(clientX) {
            const dx = clientX - startX;
            const newLeft = buttonLeft + dx;
            const maxLeft = self.sliderTrack.clientWidth - self.buttonSlide.clientWidth - 10;
            const minLeftOffset = maxLeft - 20;

            if (newLeft < maxLeft) {
                self.buttonSlide.style.left = 0;
            } else if (newLeft > minLeftOffset) {
                self.buttonSlide.style.left = maxLeft;
            }
        }

        setTimeout(() => {
            if (!document.querySelector('.block-black__friday').classList.contains('active')) {
                document.querySelector("[data-button-slider]").style.right = '0px';
                document.querySelector("[data-button-slider]").style.left = 'unset';
        
                setTimeout(() => {
                    document.querySelector("[data-slider-track]").innerHTML = 'Activeren <span class="dots"></span>';
                    document.querySelector('[data-black-friday]')?.classList.add('loading');
        
                    setTimeout(() => {
                        document.querySelector('[data-black-friday]')?.classList.add('loaded');
                    }, 1000);
        
                    setTimeout(() => {
                        document.querySelector('[data-black-friday]')?.classList.add('active');
                        document.querySelector('.block-black__friday')?.classList.add('active');
                        document.querySelector('[data-message]')?.classList.remove('hidden');

                        document.querySelector('.section-collection')?.classList.add('active');
                    }, 1500);
        
                }, 500);
            }
        
        }, 7000);
    }
}
customElements.define('black-friday', BlackFriday);